(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bm-description-2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-description')) {
    customElements.define(
      'bm-description',
      class extends HTMLElement {
        connectedCallback() {
          this.body = this.querySelector('[data-body]');
          this.toggle = this.querySelector('[data-toggle]');
          if (!this.body || !this.toggle) return;

          this.onClick = this.onClick.bind(this);
          this.measure = this.measure.bind(this);
          this.toggle.addEventListener('click', this.onClick);
          this.body.addEventListener('transitionend', (e) => {
            // Une fois deplie, on relache la contrainte : le contenu peut
            // encore grandir (images chargees apres coup).
            if (e.propertyName !== 'max-block-size' && e.propertyName !== 'max-height') return;
            if (this.hasAttribute('data-expanded')) this.body.style.maxBlockSize = 'none';
          });

          this.measure();
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(this.measure);
            this.observer.observe(this.body.firstElementChild || this.body);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        collapsedHeight() {
          const raw = getComputedStyle(this).getPropertyValue('--bm-desc-max');
          return parseInt(raw, 10) || 180;
        }

        measure() {
          if (this.hasAttribute('data-expanded')) return;
          const limit = this.collapsedHeight();
          const full = this.body.scrollHeight;
          // Marge de tolerance : inutile d'afficher un bouton pour 20px.
          if (full <= limit + 24) {
            this.setAttribute('data-short', '');
            this.body.style.maxBlockSize = 'none';
          } else {
            this.removeAttribute('data-short');
            this.body.style.maxBlockSize = limit + 'px';
          }
        }

        onClick() {
          const open = this.toggle.getAttribute('aria-expanded') === 'true';
          if (open) {
            // Figer la hauteur courante donne un point de depart a la
            // transition. Le reflow force est synchrone : contrairement a
            // requestAnimationFrame, il s'execute meme dans un onglet en
            // arriere-plan, ou le repli resterait sinon bloque.
            this.body.style.maxBlockSize = this.body.scrollHeight + 'px';
            void this.body.offsetHeight;
            this.removeAttribute('data-expanded');
            this.toggle.setAttribute('aria-expanded', 'false');
            this.body.style.maxBlockSize = this.collapsedHeight() + 'px';
          } else {
            this.setAttribute('data-expanded', '');
            this.toggle.setAttribute('aria-expanded', 'true');
            this.body.style.maxBlockSize = this.body.scrollHeight + 'px';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
